<template>
  <div :style="{ position: 'relative', height: height, width: '100%' }">
    <Bar
      :chart-options="chartOptions"
      :chart-data="chartData"
      :chart-id="chartId"
      :dataset-id-key="datasetIdKey"
      :plugins="plugins"
      :css-classes="cssClasses"
      :styles="styles"
      :width="width"
      :height="heightNum"
    />
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs/legacy';

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from 'chart.js';

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

export default {
    name: 'SacBarsChart',
    components: { Bar },
    props: {
        data: { type: Object, required: true },
        height: { type: String, default: '380px' },
    },
    data() {
        return {
            chartId: 'sac-bars-chart',
            datasetIdKey: 'label',
            width: 400,
            cssClasses: '',
            styles: {},
            plugins: [],
            chartOptions: {
                indexAxis: 'y',
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: { beginAtZero: true, max: 100 },
                    y: { grid: { display: false } },
                },
                plugins: { legend: { display: false } },
            },
        };
    },
    computed: {
        chartData() {
            return this.data || { labels: [], datasets: [] };
        },
        heightNum() {
            return parseInt(this.height, 10) || 380;
        },
    },
};
</script>
